module.exports = __webpack_public_path__ + "img/type2-3.bce6cb8d.png";